// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__PGk-B","separator":"Breadcrumbs_separator__uXtRZ"};